
import { validationMixin } from "vuelidate";
import { SistemaMixin } from "@/modules/Application";
import bancosData, { BancosDataRequired } from "./BancosData";
import { mask } from "vue-the-mask";
import { mapGetters } from "vuex";
import { MONEY as settingMoney } from "@/modules/Application";
import { Money } from "v-money";
import _ from "lodash";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import {
  getStatusSicoob,
  testarConexaoSicoob,
} from "@/core/services/sicoob.service";
import {
  getStatusSicredi,
  testarConexaoSicredi,
} from "@/core/services/sicredi.service";

export default {
  name: "app-bancos-form",
  props: {
    url: {
      type: String,
    },
    banco: {
      type: Object,
      default: () => {},
    },
  },
  directives: {
    mask,
  },
  components: {
    Money,
    VueSelect,
  },
  mixins: [validationMixin, SistemaMixin],
  data() {
    return {
      tabIndex: 0,
      form: {},
      bancos: [],
      configMoney: settingMoney,
      tipos: [
        {
          type: "savings",
          description: "Conta Poupança",
        },
        {
          type: "checking",
          description: "Conta Corrente",
        },
      ],
      tiposChavePixCarne: [
        { value: "", text: "Selecione" },
        { value: "cpf", text: "CPF" },
        { value: "cnpj", text: "CNPJ" },
        { value: "telefone", text: "Telefone" },
        { value: "email", text: "E-mail" },
        { value: "aleatoria", text: "Chave aleatória" },
      ],
      bancoFilled: false,
      bancoSelected: null,
      sicoobCollapsed: false,
      sicrediPossuiXApiKey: false,
      sicrediPossuiPassword: false,
      certificadoDisponivel: false,
      testandoConexao: false,
      testandoConexaoSicredi: false,
      tiposCobrancaSicredi: [
        { value: "NORMAL", text: "Boleto normal" },
        { value: "HIBRIDO", text: "Boleto híbrido (com QR Code Pix)" },
      ],
      especiesDocumentoSicredi: [
        "DUPLICATA_MERCANTIL_INDICACAO",
        "DUPLICATA_RURAL",
        "NOTA_PROMISSORIA",
        "NOTA_PROMISSORIA_RURAL",
        "NOTA_SEGUROS",
        "RECIBO",
        "LETRA_CAMBIO",
        "NOTA_DEBITO",
        "DUPLICATA_SERVICO_INDICACAO",
        "OUTROS",
        "BOLETO_PROPOSTA",
        "CARTAO_CREDITO",
        "BOLETO_DEPOSITO",
      ],
    };
  },
  watch: {
    banco(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.sicrediPossuiXApiKey = false;
        this.sicrediPossuiPassword = false;
        this.form = newValue;
        this.applyPixCarneDefaults();
        this.applySicoobDefaults();
        this.applySicrediDefaults();
        this.bancos = newValue.banco_zoop ?? null;
      }
    },
    mostrarSecaoSicoob(isVisible) {
      if (isVisible && this.form && this.form.id_banco) {
        this.carregarStatusSicoob();
      }
    },
    mostrarSecaoSicredi(isVisible) {
      if (isVisible && this.form && this.form.id_banco) {
        this.carregarStatusSicredi();
      }
    },
  },
  validations: {
    form: BancosDataRequired,
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked"]),
    config() {
      return this.layoutConfig();
    },
    mostrarCampoSaldo() {
      return (
        !this.form?.id_banco || this.form.pode_editar_saldo_inicial === true
      );
    },
    mostrarSecaoSicoob() {
      const code = String(
        this.bancoSelected?.code || this.form?.banco || ""
      ).replace(/^0+/, "");
      const name = String(this.bancoSelected?.name || "").toLowerCase();
      return code === "756" || name.includes("sicoob");
    },
    mostrarSecaoSicredi() {
      if (!this.bancoSelected) return false;

      const code = String(this.bancoSelected.code || "").replace(/^0+/, "");
      const name = String(this.bancoSelected.name || "").toLowerCase();

      return code === "748" || name.includes("sicredi");
    },
    multaIsenta() {
      return String(this.form?.tipo_multa ?? "0") === "0";
    },
    jurosIsento() {
      return String(this.form?.tipo_juros_mora ?? "3") === "3";
    },
    multaValorLabel() {
      return String(this.form?.tipo_multa ?? "0") === "2"
        ? "Percentual da multa (%)"
        : "Valor da multa (R$)";
    },
    jurosValorLabel() {
      return String(this.form?.tipo_juros_mora ?? "3") === "2"
        ? "Taxa de juros mensal (%)"
        : "Valor do juros por dia (R$)";
    },
    pixKeyInputType() {
      return this.form?.tipo_chave_pix_carne === "email" ? "email" : "text";
    },
    pixKeyPlaceholder() {
      const placeholders = {
        cpf: "000.000.000-00",
        cnpj: "00.000.000/0000-00",
        telefone: "(00) 00000-0000",
        email: "financeiro@empresa.com",
        aleatoria: "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
      };

      return placeholders[this.form?.tipo_chave_pix_carne] || "Selecione o tipo da chave";
    },
    pixKeyMaxLength() {
      const lengths = {
        cpf: 14,
        cnpj: 18,
        telefone: 16,
        email: 77,
        aleatoria: 36,
      };

      return lengths[this.form?.tipo_chave_pix_carne] || 77;
    },
  },
  async mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getDataInit();
  },
  methods: {
    async setBanco(banco) {
      this.bancoSelected = banco;
      this.bancoFilled = Boolean(banco);

      const codigo = String(banco?.code || "").replace(/^0+/, "");
      if (codigo === "748" && !this.form?.id_banco) {
        this.form.ambiente_api = "producao";
        this.applySicrediDefaults();
      }
    },
    async getDataInit() {
      this.sicrediPossuiXApiKey = false;
      this.sicrediPossuiPassword = false;
      this.form = new bancosData({});
      this.applyPixCarneDefaults();
      this.applySicoobDefaults();
      this.applySicrediDefaults();
      if (this.banco.id_banco) {
        this.form = this.banco;
        this.applyPixCarneDefaults();
        this.applySicoobDefaults();
        this.applySicrediDefaults();
        this.setBanco(this.banco.banco_zoop);
        if (this.mostrarSecaoSicoob) {
          this.carregarStatusSicoob();
        }
        if (this.mostrarSecaoSicredi) {
          this.carregarStatusSicredi();
        }
        return;
      }
    },
    applyPixCarneDefaults() {
      this.form.tipo_chave_pix_carne = this.form.tipo_chave_pix_carne || "";
      this.form.chave_pix_carne = this.formatPixKeyForDisplay(
        this.form.chave_pix_carne || "",
        this.form.tipo_chave_pix_carne
      );
    },
    onPixKeyTypeChange(newType) {
      const oldType = this.form.tipo_chave_pix_carne || "";
      const currentKey = String(this.form.chave_pix_carne || "").trim();

      if (oldType && oldType !== newType && currentKey) {
        this.form.chave_pix_carne = "";
      }

      this.form.tipo_chave_pix_carne = newType || "";

      if (!oldType && currentKey && newType) {
        this.form.chave_pix_carne = this.formatPixKeyForDisplay(currentKey, newType);
      }

      if (!newType) {
        this.form.chave_pix_carne = "";
      }
    },
    onPixKeyInput(value) {
      this.form.chave_pix_carne = this.formatPixKeyForDisplay(
        value,
        this.form.tipo_chave_pix_carne
      );
    },
    formatPixKeyForDisplay(value, type) {
      const stringValue = String(value || "");

      if (type === "cpf") {
        const digits = stringValue.replace(/\D/g, "").slice(0, 11);
        return digits
          .replace(/^(\d{3})(\d)/, "$1.$2")
          .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
          .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4");
      }

      if (type === "cnpj") {
        const raw = stringValue
          .trim()
          .replace(/[^A-Za-z0-9]/g, "")
          .toUpperCase();
        const cnpj = (raw.slice(0, 12) + raw.slice(12).replace(/\D/g, ""))
          .slice(0, 14);

        return cnpj
          .replace(/^(.{2})(.)/, "$1.$2")
          .replace(/^(.{2})\.(.{3})(.)/, "$1.$2.$3")
          .replace(/^(.{2})\.(.{3})\.(.{3})(.)/, "$1.$2.$3/$4")
          .replace(/^(.{2})\.(.{3})\.(.{3})\/(.{4})(.)/, "$1.$2.$3/$4-$5");
      }

      if (type === "telefone") {
        const hasInternationalPrefix = stringValue.trim().startsWith("+");
        let digits = stringValue.replace(/\D/g, "");

        if (hasInternationalPrefix && !digits.startsWith("55")) {
          return `+${digits.slice(0, 15)}`;
        }

        if (hasInternationalPrefix && digits.startsWith("55")) {
          digits = digits.slice(2);
        } else if (digits.length > 11 && digits.startsWith("55")) {
          digits = digits.slice(2);
        }

        digits = digits.slice(0, 11);

        if (digits.length <= 10) {
          return digits
            .replace(/^(\d{2})(\d)/, "($1) $2")
            .replace(/^(\(\d{2}\) \d{4})(\d)/, "$1-$2");
        }

        return digits
          .replace(/^(\d{2})(\d)/, "($1) $2")
          .replace(/^(\(\d{2}\) \d{5})(\d)/, "$1-$2");
      }

      if (type === "email" || type === "aleatoria") {
        return stringValue.trim().toLowerCase();
      }

      return stringValue;
    },
    normalizeCnpjPix(value) {
      return String(value || "")
        .trim()
        .replace(/[^A-Za-z0-9]/g, "")
        .toUpperCase();
    },
    isValidCpfPix(value) {
      const cpf = String(value || "").replace(/\D/g, "");

      if (!/^\d{11}$/.test(cpf) || /^(\d)\1{10}$/.test(cpf)) return false;

      for (let digit = 9; digit < 11; digit++) {
        let sum = 0;

        for (let index = 0; index < digit; index++) {
          sum += Number(cpf[index]) * (digit + 1 - index);
        }

        let expected = (10 * sum) % 11;
        if (expected === 10) expected = 0;
        if (Number(cpf[digit]) !== expected) return false;
      }

      return true;
    },
    isValidCnpjPix(value) {
      const cnpj = this.normalizeCnpjPix(value);

      if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpj) || /^([A-Z0-9])\1{13}$/.test(cnpj)) {
        return false;
      }

      const calculateDigit = (base, weights) => {
        const sum = weights.reduce(
          (total, weight, index) => total + (base.charCodeAt(index) - 48) * weight,
          0
        );
        const rest = sum % 11;
        return String(rest < 2 ? 0 : 11 - rest);
      };
      const firstDigit = calculateDigit(cnpj.slice(0, 12), [
        5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2,
      ]);
      const secondDigit = calculateDigit(cnpj.slice(0, 12) + firstDigit, [
        6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2,
      ]);

      return cnpj.slice(-2) === firstDigit + secondDigit;
    },
    applySicoobDefaults() {
      this.form.tipo_multa =
        this.form.tipo_multa === undefined || this.form.tipo_multa === null
          ? "0"
          : String(this.form.tipo_multa);
      this.form.dias_multa =
        this.form.dias_multa === undefined || this.form.dias_multa === null
          ? ""
          : this.form.dias_multa;
      this.form.valor_multa =
        this.form.valor_multa === undefined || this.form.valor_multa === null
          ? ""
          : this.form.valor_multa;
      this.form.tipo_juros_mora =
        this.form.tipo_juros_mora === undefined ||
        this.form.tipo_juros_mora === null
          ? "3"
          : String(this.form.tipo_juros_mora);
      this.form.dias_juros_mora =
        this.form.dias_juros_mora === undefined ||
        this.form.dias_juros_mora === null
          ? ""
          : this.form.dias_juros_mora;
      this.form.valor_juros_mora =
        this.form.valor_juros_mora === undefined ||
        this.form.valor_juros_mora === null
          ? ""
          : this.form.valor_juros_mora;
      this.form.dias_limite_pagamento =
        this.form.dias_limite_pagamento === undefined ||
        this.form.dias_limite_pagamento === null ||
        this.form.dias_limite_pagamento === ""
          ? 30
          : Number(this.form.dias_limite_pagamento);
      for (let index = 1; index <= 5; index++) {
        const field = `mensagem_instrucao_${index}`;
        this.form[field] = this.form[field] || "";
      }
    },
    applySicrediDefaults() {
      const configAtual = this.form?.config || {};
      const sicrediAtual = configAtual?.sicredi || {};
      const xApiKeyMascarada = sicrediAtual.x_api_key === "********";
      const passwordMascarada = sicrediAtual.password === "********";

      if (xApiKeyMascarada) this.sicrediPossuiXApiKey = true;
      if (passwordMascarada) this.sicrediPossuiPassword = true;

      this.$set(this.form, "config", {
        ...configAtual,
        sicredi: {
          username: "",
          especie_documento: "DUPLICATA_MERCANTIL_INDICACAO",
          tipo_cobranca: "NORMAL",
          ...sicrediAtual,
          x_api_key: xApiKeyMascarada ? "" : sicrediAtual.x_api_key || "",
          password: passwordMascarada ? "" : sicrediAtual.password || "",
        },
      });
      this.form.posto_beneficiario = this.form.posto_beneficiario || "";
      this.form.codigo_convenio = this.form.codigo_convenio || "";
    },
    mensagemLength(index) {
      return String(this.form[`mensagem_instrucao_${index}`] || "").length;
    },
    parseNumber(value) {
      if (value === undefined || value === null || value === "") return 0;
      if (typeof value === "number") return value;
      const normalized = String(value).replace(/\./g, "").replace(",", ".");
      const parsed = Number(normalized);
      return Number.isFinite(parsed) ? parsed : 0;
    },
    validarCobrancaSicoob() {
      if (!this.mostrarSecaoSicoob) return true;

      if (
        String(this.form.tipo_multa) !== "0" &&
        (Number(this.form.dias_multa) <= 0 ||
          this.parseNumber(this.form.valor_multa) <= 0)
      ) {
        this.$toast.error(
          "Para multa, informe dias e valor maiores que zero."
        );
        return false;
      }

      if (
        String(this.form.tipo_juros_mora) !== "3" &&
        (Number(this.form.dias_juros_mora) <= 0 ||
          this.parseNumber(this.form.valor_juros_mora) <= 0)
      ) {
        this.$toast.error(
          "Para juros, informe dias e valor maiores que zero."
        );
        return false;
      }

      this.form.dias_limite_pagamento =
        this.form.dias_limite_pagamento === undefined ||
        this.form.dias_limite_pagamento === null ||
        this.form.dias_limite_pagamento === ""
          ? 30
          : Number(this.form.dias_limite_pagamento);

      const diasMulta =
        String(this.form.tipo_multa) === "0" ? 0 : Number(this.form.dias_multa);
      const diasJuros =
        String(this.form.tipo_juros_mora) === "3"
          ? 0
          : Number(this.form.dias_juros_mora);

      if (
        Number(this.form.dias_limite_pagamento) < diasMulta ||
        Number(this.form.dias_limite_pagamento) < diasJuros
      ) {
        this.$toast.error(
          "Dias limite para pagamento deve ser maior ou igual aos dias de multa e juros."
        );
        return false;
      }

      for (let index = 1; index <= 5; index++) {
        const field = `mensagem_instrucao_${index}`;
        if (String(this.form[field] || "").length > 40) {
          this.$toast.error(
            "Cada mensagem de instrução deve ter no máximo 40 caracteres."
          );
          return false;
        }
      }

      return true;
    },
    validarCobrancaSicredi() {
      if (!this.mostrarSecaoSicredi || !this.form.integracao_api) return true;

      this.applySicrediDefaults();
      const sicredi = this.form.config.sicredi;
      const xApiKey = String(sicredi.x_api_key || "").trim();
      const username = String(sicredi.username || "").trim();
      const password = String(sicredi.password || "");
      const cooperativa = String(this.form.agencia || "").trim();
      const posto = String(this.form.posto_beneficiario || "").trim();
      const codigoBeneficiario = String(this.form.codigo_convenio || "").trim();

      if (!xApiKey && !this.sicrediPossuiXApiKey) {
        this.$toast.error("Informe a x-api-key Sicredi.");
        return false;
      }
      if (xApiKey && xApiKey.length !== 36) {
        this.$toast.error("A x-api-key Sicredi deve possuir 36 caracteres.");
        return false;
      }
      if (username.length !== 9) {
        this.$toast.error("O username Sicredi deve possuir 9 caracteres.");
        return false;
      }
      if (!password && !this.sicrediPossuiPassword) {
        this.$toast.error("Informe o código de acesso/password do Sicredi.");
        return false;
      }
      if (cooperativa.length !== 4) {
        this.$toast.error("A cooperativa Sicredi deve possuir 4 caracteres.");
        return false;
      }
      if (posto.length !== 2) {
        this.$toast.error("O posto Sicredi deve possuir 2 caracteres.");
        return false;
      }
      if (codigoBeneficiario.length !== 5) {
        this.$toast.error(
          "O código do beneficiário Sicredi deve possuir 5 caracteres."
        );
        return false;
      }
      if (username !== `${codigoBeneficiario}${cooperativa}`) {
        this.$toast.error(
          "O username Sicredi deve ser o código do beneficiário seguido da cooperativa."
        );
        return false;
      }
      if (!sicredi.especie_documento) {
        this.$toast.error("Selecione a espécie do documento Sicredi.");
        return false;
      }
      if (!["NORMAL", "HIBRIDO"].includes(sicredi.tipo_cobranca)) {
        this.$toast.error("Selecione o tipo de cobrança Sicredi.");
        return false;
      }
      if (
        sicredi.tipo_cobranca === "HIBRIDO" &&
        (String(this.form.tipo_multa ?? "0") !== "0" ||
          String(this.form.tipo_juros_mora ?? "3") !== "3")
      ) {
        this.$toast.error(
          "Para manter o boleto híbrido com QR Code, deixe juros e multa com carência desativados."
        );
        return false;
      }

      return true;
    },
    validarPixCarne() {
      const type = String(this.form.tipo_chave_pix_carne || "");
      const key = String(this.form.chave_pix_carne || "").trim();
      const validTypes = ["cpf", "cnpj", "telefone", "email", "aleatoria"];

      if ((this.form.pix_carne_padrao || key) && !validTypes.includes(type)) {
        this.$toast.error("Selecione o tipo da Chave PIX para o Carnê Loja.");
        return false;
      }

      if (this.form.pix_carne_padrao && !key) {
        this.$toast.error(
          "Informe a Chave PIX antes de marcar a conta como padrão para o Carnê Loja."
        );
        return false;
      }

      if (!key) return true;

      const validators = {
        cpf: () => this.isValidCpfPix(key),
        cnpj: () => this.isValidCnpjPix(key),
        telefone: () => {
          if (key.startsWith("+")) {
            return /^\+[1-9]\d{7,14}$/.test(key);
          }

          return /^[1-9]\d{9,10}$/.test(key.replace(/\D/g, ""));
        },
        email: () => key.length <= 77 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(key),
        aleatoria: () =>
          /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
            key
          ),
      };
      const messages = {
        cpf: "Informe um CPF válido para utilizar como Chave PIX.",
        cnpj: "Informe um CNPJ válido para utilizar como Chave PIX.",
        telefone: "Informe um telefone válido para utilizar como Chave PIX.",
        email: "Informe um e-mail válido para utilizar como Chave PIX.",
        aleatoria: "Informe uma Chave PIX aleatória válida.",
      };

      if (!validators[type]()) {
        this.$toast.error(messages[type]);
        return false;
      }

      return true;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    setActivePreviousTab() {
      this.tabIndex = parseInt(localStorage.getItem("builderTab")) || 0;
      const links = this.$refs["builder-tab"].querySelectorAll(".nav-link");

      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      this.$refs["builder-tab"]
        .querySelector(`[data-tab="${this.tabIndex}"]`)
        .classList.add("active");
    },
    setActiveTab(event) {
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");

      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      this.tabIndex = parseInt(event.target.getAttribute("data-tab"));

      event.target.classList.add("active");
    },
    async onSubmit() {
      const submitButton = this.$refs["submit_novo_banco"];

      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          return;
        }

        if (
          !this.validarPixCarne() ||
          !this.validarCobrancaSicoob() ||
          !this.validarCobrancaSicredi()
        ) {
          return;
        }

        submitButton.classList.add("spinner", "spinner-light", "spinner-right");

        if (this.bancoSelected) {
          this.form.banco = this.bancoSelected.code;
          this.form.id_banco_zoop = this.bancoSelected.id_banco_zoop;
        }

        if (this.mostrarSecaoSicoob) {
          this.form.ambiente_api = "producao";
        }
        if (this.mostrarSecaoSicredi) {
          this.form.ambiente_api = "producao";
        }
        this.applySicoobDefaults();
        this.applySicrediDefaults();

        const payload = { ...this.form };
        payload.config = { ...(this.form.config || {}) };
        if (!this.mostrarSecaoSicredi && payload.config.sicredi) {
          delete payload.config.sicredi;
        }
        delete payload.banco_zoop;
        delete payload.created_at;
        delete payload.updated_at;
        delete payload.deleted_at;

        await this.$http.post(this.url, payload);

        this.$router.push({ name: "bancosLista" });
      } catch (error) {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
      }
    },
    onSearchBancos(search, loading) {
      if (search.length) {
        loading(true);
        this.searchBanco(loading, search, this);
      }
    },
    searchBanco: _.debounce(async (loading, search, vm) => {
      vm.bancos = await vm.getBancoZoopByCode(search);
      loading(false);
    }, 350),
    async carregarStatusSicoob() {
      if (!this.form?.id_banco) return;
      try {
        const { data } = await getStatusSicoob(this.form.id_banco);
        this.certificadoDisponivel = Boolean(data?.certificado_disponivel);
        this.form.status_api = data?.status_api || this.form.status_api || "";
      } catch (error) {
        this.certificadoDisponivel = false;
        this.form.status_api = this.form.status_api || "";
      }
    },
    async testarConexaoSicoob() {
      if (this.testandoConexao || !this.form?.id_banco) return;
      this.testandoConexao = true;
      try {
        await testarConexaoSicoob(this.form.id_banco);
        this.certificadoDisponivel = true;
        this.$toast.success("Conexão com Sicoob realizada com sucesso.");
      } catch (error) {
        const payload = error?.response?.data || {};
        const tipo = String(
          payload?.error || payload?.type || ""
        ).toLowerCase();
        if (
          tipo.includes("certificado") ||
          payload?.certificado_disponivel === false
        ) {
          this.certificadoDisponivel = false;
          this.$toast.error(
            "Empresa não possui certificado digital cadastrado. Cadastre o certificado no emitente antes de ativar a integração Sicoob."
          );
        } else {
          this.$toast.error(
            payload?.msg ||
              payload?.message ||
              "Não foi possível conectar ao Sicoob. Verifique as credenciais."
          );
        }
      } finally {
        this.testandoConexao = false;
      }
    },
    async carregarStatusSicredi() {
      if (!this.form?.id_banco) return;
      try {
        const { data } = await getStatusSicredi(this.form.id_banco);
        this.form.status_api = data?.status_api || this.form.status_api || "";
      } catch (error) {
        this.form.status_api = this.form.status_api || "";
      }
    },
    async testarConexaoSicredi() {
      if (this.testandoConexaoSicredi || !this.form?.id_banco) return;
      this.testandoConexaoSicredi = true;
      try {
        await testarConexaoSicredi(this.form.id_banco);
        this.form.status_api = "ativo";
        this.$toast.success("Conexão com o Sicredi realizada com sucesso.");
      } catch (error) {
        const payload = error?.response?.data || {};
        this.form.status_api = "erro";
        this.$toast.error(
          payload?.msg ||
            payload?.message ||
            "Não foi possível conectar ao Sicredi. Verifique as credenciais."
        );
      } finally {
        this.testandoConexaoSicredi = false;
      }
    },
  },
};
